import {getGistContent} from '@/api/cla'

const reservedGistFileNames = ['metadata'];

export function normalizeMeta(meta) {
  if (meta) {
    res.meta = meta;
    var links = meta.link ? parse_link_header(meta.link) : null;

    res.hasMore = meta.hasMore || (!!links && !!links.next);

    res.getMore = res.hasMore ? function () {

        res.loaded = false;
        res.loading = true;

        if (links.next) {
            args.url = links.next;
        } else {
            args.arg.page = args.arg.page + 1 || 2;
        }

        exec(type, res, args, call);

    } : null;
  }
}

export function getGistAttribute(gist, attribute) {
  var attr;
  if (gist && gist.files) {
      Object.keys(gist.files).some((file) =>{
          if (reservedGistFileNames.indexOf(file) < 0) {
              attr = file;
              return true;
          }
      });
      attr = gist.files[attr][attribute] ? gist.files[attr][attribute] : attr;
  }
  return attr;
}

export function getGistContent2(repoId, orgId, gist_url, gist_version) {
  let gistContent = {}
  var args = {
      repoId: repoId,
      orgId: orgId
  };
  if (gist_url) {
      args.gist = {
          gist_url: gist_url,
          gist_version: gist_version
      };
  }
  return getGistContent(args).then((res) =>{
      gistContent.claText = res.raw

      if (res.meta) {
          try {
              var metaString = res.meta.replace(/<p>|<\/p>|\n|\t/g, '');
              gistContent.customFields = JSON.parse(metaString);
              gistContent.customKeys = Object.keys(gistContent.customFields);
              gistContent.hasCustomFields = true;
              return gistContent
          } catch (ex) {
              reject(ex);
          }
      } else {
          return gistContent
      }
  })
}

export function dataURLToBlob(dataURL) {
  // Code taken from https://github.com/ebidel/filer.js
  var parts = dataURL.split(';base64,');
  var contentType = parts[0].split(":")[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}


// WEBPACK FOOTER //
// ./src/util/util.js